import { PALETTE } from '../../common/styles/palette';
export const styles = (theme: any) => {
    return {
        buttonContainer: {
            justifyContent: 'flex-end',
            '@media (max-width: 1024px)': {
                justifyContent: 'center'
            },
            display: 'flex',
            paddingRight: '0px !important'
        },
        listItemContainer: {
            alignItems: 'center',
            padding: '5px'
        },
        listPreviewImage: {
            marginLeft: '5px',
            marginRight: '5px',
            marginTop: '17px',
            marginBottom: '17px',
            width: '60px',
            height: '60px',
            border: '1px solid black',
            backgroundColor: PALETTE.UI.Images.BackgroundColor
        },
        listPreviewImageBase64: {
            marginLeft: '5px',
            marginRight: '5px',
            marginTop: '17px',
            marginBottom: '17px',
            width: '60px',
            height: '60px',
            border: '1px solid black',
        },
        rightAlignedButtons: {
            justifyContent: 'flex-end',
            display: 'flex'
        },
    }
}